export const COUPON_TYPE_UNIT = {
  percent: '%',
  amount: '원',
};
